module.exports = __webpack_public_path__ + "img/point_session_512x512.df185cbd.png";